<template>
  <div
    class="buttons is-justify-center"
    style="width: 100%; height: 100%; margin: auto; margin-top: 2px"
  >
    <button
      v-tooltip="tooltip ? 'Editar empresa' : null"
      class="button is-dark"
      @click="editCompany()"
    >
      <span class="icon">
        <i class="material-icons has-text-white	">create</i>
      </span>
    </button>
    <button
      v-tooltip="tooltip ? 'Eliminar' : null"
      class="button is-danger"
      v-on:click="deleteCompany()"
    >
      <span class="icon">
        <i class="material-icons">delete_forever</i>
      </span>
    </button>
  </div>
</template>
<script>
import apiServices from "@/services/yungol-services";
export default {
  data() {
    return {
      params: this.$parent.params,
      tooltip: true,
    };
  },
  methods: {
    // Actions
    async deleteCompany() {
      const config = {
        title: "¿Estás seguro?",
        text: "Al eliminar no se podrá recuperar la empresa después.",
        icon: "warning",
        showCancelButton: true,
        cancelButtonColor: "#de5b5b",
        confirmButtonText: "Sí, eliminar",
      };
      this.$swal(config).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const deleteCompany = await apiServices.delete(
              `/empresa/${this.params.value}`
            );

            if (deleteCompany.data) {
              await this.$swal({
                title: this.params.data.nombre,
                text: "La empresa se elimino correctamente.",
                icon: "success",
                showConfirmButton: false,
                timer: 1700,
              });
              this.params.api.applyTransaction({
                remove: [this.params.node.data],
              });
            } else {
              await this.$swal({
                title: this.params.data.nombre,
                text: "Error al eliminar el empresa.",
                icon: "error",
                showConfirmButton: false,
                timer: 1700,
              });
            }
          } catch (err) {
            await this.$swal({
              text: "Error al eliminar el proceso.",
              icon: "error",
              showConfirmButton: false,
              timer: 1700,
            });
            console.log(err);
          }
        }
      });
    },
    async editCompany() {
      try {
        this.$emit("updateCompany", this.params.data);
      } catch (error) {
        await this.$swal({
          text: "Error al editar la empresa.",
          icon: "error",
          showConfirmButton: false,
          timer: 1700,
        });
      }
    },
    setToolIfPinnedRow() {
      const pinnedTopRowCount = this.params.api.getPinnedTopRowCount();
      if (pinnedTopRowCount > 0) {
        const data = this.params.api.getPinnedTopRow(0).data._id;
        const result = data !== this.params.value;
        return (this.tooltip = result);
      }
    },
  },
  created() {
    this.setToolIfPinnedRow();
  },
};
</script>

<style lang="scss">
.no-border {
  border: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/empresas/components/ButtonsActionCompany.vue